// SDP zlib + base64url 编解码（与 Worker 端 sdp.ts 对应）

import pako from 'pako';

export function encodeSdp(sdp: string): string {
  const compressed = pako.deflate(sdp, { level: 6 });
  return bytesToBase64Url(compressed);
}

export function decodeSdp(encoded: string): string {
  const bytes = base64UrlToBytes(encoded);
  return pako.inflate(bytes, { to: 'string' });
}

function bytesToBase64Url(bytes: Uint8Array): string {
  let bin = '';
  for (let i = 0; i < bytes.length; i++) {
    bin += String.fromCharCode(bytes[i]);
  }
  const b64 = btoa(bin);
  return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function base64UrlToBytes(input: string): Uint8Array {
  const pad = input.length % 4 === 0 ? '' : '='.repeat(4 - (input.length % 4));
  const b64 = input.replace(/-/g, '+').replace(/_/g, '/') + pad;
  const bin = atob(b64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) {
    bytes[i] = bin.charCodeAt(i);
  }
  return bytes;
}
